import { Injectable } from '@angular/core';
import { Observable, Subject } from 'rxjs';

/**
 * Service that indicates whether or not the app is currently changing pages.
 */
@Injectable({
    providedIn: 'root'
})
export class IsLoadingService {
    private _counter: number = 0;
    private _subject = new Subject<boolean>();
    public get observable(): Observable<boolean> {
        return this._subject;
    }

    public setLoading(): void {
        this._counter++;
        if (this._counter === 1) {
            this._subject.next(true);
        }
    }

    public clearLoading(): void {
        setTimeout(() => {
            this._counter = Math.max(0, this._counter - 1);
            if (this._counter === 0) {
                this._subject.next(false);
            }
        });
    }
}
